<template>
	<div class="maxMaxth evebt">
		<div class="cRKA8AT8lf2bItsMSztA" v-if="$store.state.vuex_token_head">
			<div >
				<section class="iODDzDZbB06hkkF6ltjq">
					<div class="vy918omw_N7rBkJ235XX"
						style="--row-align: center; --mode: flex; --column-align: center;">
						<div class="lop_top" :style="{
								backgroundImage:`url(${img_hb_frame})`
							}" style="background-position: 0px 0px;background-size: 100% 100%;">
							<i class="yj5rHjAv0U7RlHMzWr7F img skeleton-box" :style="{
									backgroundImage:`url(${_coloImg})`
								}" style="display: inline-block; position: relative; width: 0.3rem; height: 0.3rem;background-position: -7.15714rem -2.79643rem; background-size: 7.77857rem 7.59107rem;"></i>
						</div>
						<section  class="_top_currency-count" style="font-size: 0.18rem;">
							<div class="countTextBox" @click="animate">
								<span class="SSAbrhtT3U690CrzLUd5 count-to">
									<span class="notranslate"  style="font-size: 0.2rem;">{{betRebateDatList.balance||'0,00'}}</span>
								</span>
								<svg-icon icon-class="comm_icon_sx--svgSprite:all" />
							</div>
						</section>
					</div>
				</section>
			</div>
			<div class="a7neOLNNGzlPwu32tGO4">
				<div class="RnNfgaFEYzhMdHzQIun2" style="display: flex;align-items: center;">
					<span>Nível de Atividade</span>
					<span class="XGEOwGXgDL9a2SebPqvj" style="display: flex;align-items: center;">
						<i  class="lobby-image lobby-image"  style="display: inline-flex; justify-content: center; align-items: center;margin: 0 .05rem;"><svg width="1em" height="1em" fill="currentColor" class="" viewBox="0 0 22.851 24">
						  <g id="55503760420f838aed1fc3f527395aaf-Group_2414" data-name="Group 2414" transform="translate(-1789.99 -100.756)">
						    <path id="55503760420f838aed1fc3f527395aaf-Path_512" data-name="Path 512" d="M1819.742,100.806l-13.124,11.241a.377.377,0,0,0,.1.636l5.606,2.242-4.769,9.538a.2.2,0,0,0,.314.24l12.883-11.548a.377.377,0,0,0-.12-.633l-5.422-2.013,4.837-9.458A.2.2,0,0,0,1819.742,100.806Z" transform="translate(-12.611)"></path>
						    <g id="55503760420f838aed1fc3f527395aaf-Group_2413" data-name="Group 2413" transform="translate(1789.99 100.85)">
						      <path id="55503760420f838aed1fc3f527395aaf-Path_513" data-name="Path 513" d="M1836.638,110.7l-.734,1.436a.629.629,0,0,0,.159.77,8.83,8.83,0,0,1-5.637,15.63h-.035a.867.867,0,0,0-.585.219l-1.751,1.57a.341.341,0,0,0,.158.588,11.422,11.422,0,0,0,9.053-20.355A.42.42,0,0,0,1836.638,110.7Z" transform="translate(-1819 -108.278)"></path>
						      <path id="55503760420f838aed1fc3f527395aaf-Path_514" data-name="Path 514" d="M1792.582,112.579a8.844,8.844,0,0,1,8.834-8.834c.178,0,.355.006.531.017a.628.628,0,0,0,.45-.147l1.851-1.586a.319.319,0,0,0-.13-.551,11.421,11.421,0,0,0-9.479,20.292.375.375,0,0,0,.559-.131l.772-1.543a.559.559,0,0,0-.144-.683A8.819,8.819,0,0,1,1792.582,112.579Z" transform="translate(-1789.99 -101.154)"></path>
						    </g>
						  </g>
						</svg></i>
						{{betRebateDatList.activity}}</span>
				</div>
				
			</div>

		</div>
		
		<div style="padding: 0 .2rem;">
			<div class="lobby-lazy-loader _listItem_1bonq_17" v-for="(item,index) in betRebateDatList.list">
				<div class="_itemContent_1bonq_33">
					<div class="_name_1bonq_39">{{item.title}}</div>
					<div class="_receive-btn-box_uxbhh_17">
						<div type="button"
							:class="{
								'ui-button--success':item.receive.expired>0 && item.receive.expired<=86400,
								'ui-button--sumes':!(item.receive.expired>0 && item.receive.expired<=86400),
							}" 
							@click="liengquHuodong(item.receive.expired,item)"
							class="ui-button  ui-button--small _collect_uxbhh_24 "
							>
							<!--item.receive.expired 86400 -->
							<div class="_collect-txt_uxbhh_33">{{item.receive.title}}</div>
							<p style="font-size: .16rem;text-align: center;" v-if="item.receive.expired>0" >
								<span class="">
									<CountdownTimer :initial-time="item.receive.expired"></CountdownTimer>
								</span>
							</p>
						</div>
					</div>
				</div>
				<div class="_amountWrapper_1bonq_53"><span class="_currency_1bonq_59"><i class="lobby-image lobby-image"
							style="display: inline-flex; justify-content: center; align-items: center;"><svg width="1em"
								height="1em" fill="currentColor" class="" viewBox="0 0 24.002 24.002">
								<path id="8beec89abde61d0a657a8b133308cf01-comm_icon_sqb"
									d="M-13723,14a11.924,11.924,0,0,1-8.487-3.516A11.924,11.924,0,0,1-13735,2a11.919,11.919,0,0,1,3.516-8.484A11.924,11.924,0,0,1-13723-10a12.013,12.013,0,0,1,12,12,11.925,11.925,0,0,1-3.515,8.487A11.92,11.92,0,0,1-13723,14Zm1.44-9.328a.687.687,0,0,0-.534.286,1.021,1.021,0,0,0-.234.658,1.03,1.03,0,0,0,.1.476.892.892,0,0,0,.338.334,5.252,5.252,0,0,0,1.357.693,6.775,6.775,0,0,0,1.6.345v.81a.876.876,0,0,0,.255.651.889.889,0,0,0,.645.248.89.89,0,0,0,.655-.248.9.9,0,0,0,.244-.651V7.421a4.047,4.047,0,0,0,2.244-1.075,2.782,2.782,0,0,0,.831-2.048,2.481,2.481,0,0,0-.5-1.627,2.96,2.96,0,0,0-1.2-.882,13.009,13.009,0,0,0-1.437-.458V-1.444a2.341,2.341,0,0,1,.4.121,6.811,6.811,0,0,1,1.1.583,2.006,2.006,0,0,0,.4.2,1,1,0,0,0,.307.045.687.687,0,0,0,.534-.286,1.008,1.008,0,0,0,.23-.658,1,1,0,0,0-.1-.465.9.9,0,0,0-.323-.345,5.674,5.674,0,0,0-2.534-1.02V-4.1a.9.9,0,0,0-.244-.655.912.912,0,0,0-.655-.245.9.9,0,0,0-.645.245.855.855,0,0,0-.255.655v.855a4.04,4.04,0,0,0-2.258,1.11,2.862,2.862,0,0,0-.862,2.085,2.486,2.486,0,0,0,.518,1.648,3.083,3.083,0,0,0,1.237.9,13.2,13.2,0,0,0,1.444.469V5.65a4.586,4.586,0,0,1-.642-.141,6.013,6.013,0,0,1-1.312-.593A1.5,1.5,0,0,0-13721.559,4.674Zm-8.131-1.41h1.213a1.385,1.385,0,0,1,.721.172,1.75,1.75,0,0,1,.541.562l1.982,2.94a1.093,1.093,0,0,0,.448.421,1.227,1.227,0,0,0,.555.134,1.226,1.226,0,0,0,.786-.269.841.841,0,0,0,.338-.689,1.125,1.125,0,0,0-.225-.645l-1.141-1.71a3.076,3.076,0,0,0-.683-.758,1.944,1.944,0,0,0-.8-.352,3.266,3.266,0,0,0,1.905-1.065,3.087,3.087,0,0,0,.676-2.027,2.954,2.954,0,0,0-.951-2.361,4.243,4.243,0,0,0-2.812-.817h-3.765a1.1,1.1,0,0,0-.813.283,1.124,1.124,0,0,0-.282.81v8.4a1.146,1.146,0,0,0,.313.855,1.161,1.161,0,0,0,.854.317,1.125,1.125,0,0,0,.835-.317,1.186,1.186,0,0,0,.307-.855V3.265Zm12.492,2.268h0V3.468a1.968,1.968,0,0,1,.534.324.772.772,0,0,1,.279.614,1.1,1.1,0,0,1-.479.951,1.6,1.6,0,0,1-.333.175Zm-10.286-4.036h-2.237V-1.417h2.237a2.414,2.414,0,0,1,1.454.348,1.311,1.311,0,0,1,.448,1.11,1.311,1.311,0,0,1-.448,1.1A2.388,2.388,0,0,1-13727.483,1.5Zm8.583-.648h0a1.987,1.987,0,0,1-.589-.365.893.893,0,0,1-.286-.683,1.129,1.129,0,0,1,.49-.958,1.478,1.478,0,0,1,.386-.21V.848Z"
									transform="translate(13735.002 10)"></path>
							</svg></i><span>{{item.bonus}}</span></span><!----><span class="_time_1bonq_84">{{item.date}}</span><span
						class="_template_1bonq_99"><span class="_activeTypeName_1bonq_95">Fonte:</span><span
							class="_source-text_j64jm_17 source-text" @click="openUrlInem(item.from)">{{item.from.title}}</span></span></div>
			</div>
				
		</div>
		<!-- <div v-else style="height: 3rem;"></div> -->
		<!-- img_none_jl.webp -->
		<van-empty image-size="2.1rem" style="padding-top: 3rem;" v-if="!betRebateDatList.list || betRebateDatList.list&&!betRebateDatList.list.length" class="custom-image" :image="img_none_sj" description="Sem Registros" />
	</div>
</template>

<script>
	import {
		rewards,
		claimActivityRewards
	} from "@/apis/modules/detail.js"
	// 
	import CountdownTimer from "@/components/CountdownTimer.vue"
	import { Toast } from 'vant';
	// TaxadeRebate
	// openUrl
	export default {
		name: 'canReceive',
		components:{
			CountdownTimer
		},
		data() {
			return {
				betRebateDatList:{},
			}
		},
		created() {
			this.betRebate();
		},
		methods: {
			openUrlInem(form){
				if(item.from.jump!="#"){
					this.openUrl(form.jump);
				}
			},
			liengquHuodong(expired,item){
				// v-if="item.receive.expired>0" 
				if(expired<=0){
					this.openUrl('TaxadeRebate')
				}else{
					claimActivityRewards({
						rewards_id:item.id,
						
					}).then(({
						code,
						data,
						msg
					}) => {
						if(code==0){
							Toast.success(msg);
						}else{
							Toast.loading(msg);
						}
						// this.betRebateDatList=data;
					})
					
				}
			},
			betRebate() {
				rewards({}).then(({
					code,
					data,
					msg
				}) => {
					// data.list=[{},{}]
					this.betRebateDatList=data;
					this.$store.commit('publicFun',['open_tips',data.open_tips])
				})
			},
			tabFun(e) {
				this.$store.commit('active', e)
			},
			stickyScroLL(e) {}
		}
	}
</script>
<style>
	.v0FZl0YCkbZ5KOXk68M4 .van-dropdown-menu__bar {
		background-color: transparent;
		box-shadow: none;
		height: .5rem;

	}

	.v0FZl0YCkbZ5KOXk68M4 .van-dropdown-menu__bar .van-dropdown-menu__item {
		border: .01rem solid var(--theme-color-line);
		background-color: var(--cms-background-color-primary);
		font-size: .2rem;
		height: .5rem !important;
		transition: all .3s cubic-bezier(.645, .045, .355, 1);
		border-radius: .5rem;
		line-height: .5rem;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 11px;
		color: var(--theme-text-color-lighten) !important;
	}

	.v0FZl0YCkbZ5KOXk68M4 .van-dropdown-menu__bar .van-dropdown-menu__item .van-dropdown-menu__title {
		font-size: .2rem;
		color: var(--theme-text-color-lighten) !important;
	}

	.v0FZl0YCkbZ5KOXk68M4 .van-dropdown-menu__title::after {

		border-color: transparent transparent var(--theme-text-color-lighten) var(--theme-text-color-lighten);
	}

	.v0FZl0YCkbZ5KOXk68M4 .van-popup,
	.v0FZl0YCkbZ5KOXk68M4 .van-cell {
		background-color: transparent;
	}

	.v0FZl0YCkbZ5KOXk68M4 .van-popup--top {
		width: auto;
	}

	.v0FZl0YCkbZ5KOXk68M4 .van-overlay {
		background-color: transparent;
	}

	.v0FZl0YCkbZ5KOXk68M4 .van-dropdown-item {
		position: absolute;
		min-width: 1rem;
		left: 0;
		width: 3.15rem;
		top: .6rem !important;
		transition: .3s;
		height: 400px;
		/* overflow: initial; */
	}

	.v0FZl0YCkbZ5KOXk68M4 .van-popup {
		background-color: var(--cms-background-color-primary) !important;
		border: .01rem solid var(--theme-color-line) !important;
		border-radius: .1rem;
		box-shadow: 0 .03rem .09rem 0 rgba(0, 0, 0, .1);
		box-sizing: border-box;
	}

	.v0FZl0YCkbZ5KOXk68M4 .van-cell {
		font-size: .24rem;
		line-height: .8rem;
		min-height: .8rem;
		padding: 0 .2rem;
		color: var(--theme-text-color-lighten);
	}

	.v0FZl0YCkbZ5KOXk68M4 .van-dropdown-item__option--active {
		color: var(--theme-primary-color);
	}

	.v0FZl0YCkbZ5KOXk68M4 .van-cell__value {
		display: none;
	}

	.v0FZl0YCkbZ5KOXk68M4 .van-cell::after {
		border-bottom: none;
		color: var(--theme-text-color-lighten);
	}

	.v0FZl0YCkbZ5KOXk68M4 .van-dropdown-menu {
		position: relative;
	}

	.v0FZl0YCkbZ5KOXk68M4 .van-cell__title {


		white-space: nowrap;
	}
</style>

<style scoped>
	._receive-btn-box_uxbhh_17 {
	    display: flex;
	    flex-direction: column;
	    align-items: center;
	    justify-content: center;
	    height: .6rem
	}
	
	._receive-btn-box_uxbhh_17 ._collect_uxbhh_24 {
	    display: flex;
	    flex-direction: column;
	    align-items: center;
	    justify-content: center;
	    width: 1.48rem;
	    height: .58rem;
	    line-height: normal
	}
	.ui-button--sumes {
		background-color: var(--theme-primary-color);
		border-color: var(--theme-primary-color);
		color: var(--cms-theme-text-color-primary);
		border-radius: .14rem;
		font-size: .22rem;
	}
	.ui-button--success{
		border-radius: .14rem;
		background-color: var(--cms-primary-color);
		border-color: var(--cms-primary-color);
		color: var(--cms-theme-text-color-primary);
		font-size: .22rem;
	}
	.ui-button--success {
		
	}
	/* ._receive-btn-box_uxbhh_17 ._collect_uxbhh_24 ._collect-txt_uxbhh_33 {
	    font-size: .22rem;
	    margin-bottom: .04rem
	} */
	
	._receive-btn-box_uxbhh_17 .countdown,._receive-btn-box_uxbhh_17 .countdown span {
	    color: inherit
	}

	div._listItem_1bonq_17 {
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		height: 1.51rem;
		padding: .2rem;
		border-radius: .14rem;
		background-color: var(--cms-background-color-primary);
		color: var(--theme-text-color-darken);
		font-size: .2rem;
		margin-top: .2rem;
	}

	div._listItem_1bonq_17:first-child {
		margin-top: 0
	}

	div._listItem_1bonq_17 ._itemContent_1bonq_33 {
		display: flex;
		justify-content: space-between;
		color: var(--skin__neutral_2);
		font-size: .24rem
	}

	div._listItem_1bonq_17 ._itemContent_1bonq_33 ._name_1bonq_39 {
		height: .74rem;
		color: var(--theme-text-color-lighten);
		font-size: .24rem;
		line-height: .36rem;
		margin-right: .1rem;
		max-width: 4.52rem;
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		vertical-align: middle;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical
	}

	div._listItem_1bonq_17 ._amountWrapper_1bonq_53 {
		display: flex;
		align-items: center;
		height: .3rem;
		margin-top: .1rem
	}

	div._listItem_1bonq_17 ._amountWrapper_1bonq_53 ._currency_1bonq_59 {
		display: flex;
		align-items: center;
		color: var(--cms-primary-color);
		font-size: .2rem
	}

	div._listItem_1bonq_17 ._amountWrapper_1bonq_53 ._currency_1bonq_59>i {
		margin-top: .02rem;
		margin-right: .05rem;
		display: block !important
	}

	div._listItem_1bonq_17 ._amountWrapper_1bonq_53 ._h5ActivityCol_1bonq_70 {
		display: flex;
		align-items: center;
		color: var(--theme-secondary-color-error);
		font-size: .2rem
	}

	div._listItem_1bonq_17 ._amountWrapper_1bonq_53 ._h5ActivityCol_1bonq_70>i {
		margin-top: .02rem;
		margin-right: .05rem;
		display: block !important
	}

	div._listItem_1bonq_17 ._amountWrapper_1bonq_53 ._h5ActivityExpiredStatus_1bonq_81 {
		color: var(--theme-text-color-lighten) !important
	}

	._source-text_j64jm_17,
	div._listItem_1bonq_17 ._amountWrapper_1bonq_53 ._time_1bonq_84 {
		color: var(--theme-text-color-lighten);
		font-size: .2rem
	}

	div._listItem_1bonq_17 ._amountWrapper_1bonq_53>span {
		display: flex;
		align-items: center
	}

	div._listItem_1bonq_17 ._amountWrapper_1bonq_53>span:not(:last-child) {
		margin-right: .2rem
	}

	div._listItem_1bonq_17 ._amountWrapper_1bonq_53 ._activeTypeName_1bonq_95 {
		margin-right: .05rem;
		color: var(--skin__lead)
	}

	div._listItem_1bonq_17 ._amountWrapper_1bonq_53 ._template_1bonq_99 {
		display: inline-flex;
		align-items: center;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		line-height: 1
	}

	.v0FZl0YCkbZ5KOXk68M4 {
		display: flex;

	}

	.cRKA8AT8lf2bItsMSztA {
		height: .9rem;
		padding: 0 .2rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.a7neOLNNGzlPwu32tGO4 {
		-ms-flex-align: center;
		-ms-flex-pack: end;
		align-items: center;
		display: -ms-flexbox;
		display: flex;
		height: .5rem;
		height: .9rem;
		justify-content: flex-end;
	}

	.cRKA8AT8lf2bItsMSztA {
		display: -ms-flexbox;
		font-size: .24rem;
		line-height: 1.5;
		color: var(--theme-text-color-lighten);
	}

	.XGEOwGXgDL9a2SebPqvj {
		color: var(--cms-primary-color)
	}
</style>

<style scoped>
	.lop_top {
		width: .34rem;
		height: .34rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.ODpmAuZ5P5dWvxbKwcOf {
	    height: .7rem
	}
	.v7Gu3VSoEuypS8B9EgaJ {
	    -ms-flex-negative: 0;
	    flex-shrink: 0;
	    height: 100%;
	    width: 100%
	}
	.aG5W8rsptmZ9RO66S3cI {
		height: .7rem;
		width: 100%;
		display: flex;
		padding-right: .2rem;
		box-sizing: border-box;
		align-items: center;
		justify-content: space-between;
	}
	
	.aG5W8rsptmZ9RO66S3cI,.aG5W8rsptmZ9RO66S3cI .pxU3k4yaAHPfT3wK4R8v {
	    -ms-flex-align: center;
	    align-items: center;
	    display: -ms-flexbox;
	    display: flex;
	}
	
	.aG5W8rsptmZ9RO66S3cI .pxU3k4yaAHPfT3wK4R8v {
	    -ms-flex-pack: center;
	    cursor: pointer;
	    justify-content: center
	}
	
	.aG5W8rsptmZ9RO66S3cI .MzKJCo_kccEXopglGrWF {
	    background-color: var(--theme-table-bg-color);
	    cursor: pointer
	}
	
	.aG5W8rsptmZ9RO66S3cI .MzKJCo_kccEXopglGrWF img {
	    will-change: auto!important
	}
	
	.aG5W8rsptmZ9RO66S3cI .DvuNDsU5DEFvvcIAXWAe {
	    -ms-flex-negative: 0;
	    flex-shrink: 0;
	    margin-left: auto;
	}
	
	.aG5W8rsptmZ9RO66S3cI .DvuNDsU5DEFvvcIAXWAe .ant-btn {
	    border-radius: .1rem;
	    font-family: MicrosoftYaHeiLobby;
	    text-align: center
	}
	
 .aG5W8rsptmZ9RO66S3cI {
	    /* gap: .1rem */
	}
	
.aG5W8rsptmZ9RO66S3cI .pxU3k4yaAHPfT3wK4R8v {
	    padding: 0 .2rem;
	    position: relative
	}
	
.aG5W8rsptmZ9RO66S3cI .pxU3k4yaAHPfT3wK4R8v:after {
	    border-right: .01rem solid var(--theme-color-line);
	    content: "";
	    height: .4rem;
	    position: absolute;
	    right: 0;
	    top: 50%;
	    -webkit-transform: translateY(-50%);
	    transform: translateY(-50%)
	}
	
	.aG5W8rsptmZ9RO66S3cI .pxU3k4yaAHPfT3wK4R8v svg {
	    font-size: .16rem
	}
	
	 .aG5W8rsptmZ9RO66S3cI .DvuNDsU5DEFvvcIAXWAe .ant-btn {
	    font-size: .16rem;
	    height: .4rem;
	    padding: 0 .18rem
	}
	
	.aG5W8rsptmZ9RO66S3cI {
	    /* gap: .2rem */
	}
	
	 .aG5W8rsptmZ9RO66S3cI .pxU3k4yaAHPfT3wK4R8v {
	    margin-right: -.2rem;
	    padding: 0 .3rem
	}
	
	.aG5W8rsptmZ9RO66S3cI .pxU3k4yaAHPfT3wK4R8v svg {
	    font-size: .2rem
	}
	
	.aG5W8rsptmZ9RO66S3cI .DvuNDsU5DEFvvcIAXWAe .ant-btn {
	    font-size: .18rem;
	    height: -webkit-fit-content;
	    height: -moz-fit-content;
	    height: fit-content;
	    line-height: .2rem;
	    max-width: 1.6rem;
	    min-height: .45rem;
	    min-width: 1.2rem;
	    padding-left: .1rem;
	    padding-right: .1rem;
	    white-space: normal;
	    word-break: break-all
	}

	._top_currency-count .notranslate {
		color: var(--cms-primary-color);
		font-size: .16rem;
		 white-space: nowrap; /* 防止文本换行 */
		overflow: hidden; /* 隐藏超出容器的文本 */
		text-overflow: ellipsis; /* 在文本末尾添加省略号 */
		max-width: 1.2rem;
		display: inline-block;
		border-bottom: .01rem solid var(--cms-primary-color);
	}

	._top_currency-count .countTextBox {
		display: flex;
		align-items: center;
	}

	._top_currency-count .svg-icon {
		color: var(--cms-primary-color);
		font-size: .2rem;
		width: .2rem;
		height: .2rem;
		z-index: 10
	}

	._top_currency-count .SSAbrhtT3U690CrzLUd5 {
		display: block;
		margin: 0 .073rem 0 .1rem;
		max-width: 1.64rem;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.GgxC_2tF_TQt1DVfif5a {
		display: flex;
		align-items: center;
	}
	.ant-layout-header-conter{
		position:fixed;
		transition: .3s;
		width: 100%;
		z-index:99
	}
	.vy918omw_N7rBkJ235XX {
		padding: .06rem .084rem 0.06rem .02rem;
		border: .01rem solid var(--cms-top-btn-color);
		border-radius: .2rem;
		-ms-flex-align: var(--column-align);
		-ms-flex-pack: var(--row-align);
		align-items: var(--column-align);
		display: var(--mode);
		height: .4rem;
		justify-content: var(--row-align);
		line-height: normal;
		padding: 0 .05rem 0 .02rem;
		position: relative;
	}

	.aLXMjsO8hJ5Mj1gtyJTg .ant-dropdown {
		background: var(--cms-background-color-primary);
		border: .01rem solid var(--theme-color-line);
		border-radius: .1rem;
		transition: .3s;
	}

	.aLXMjsO8hJ5Mj1gtyJTg .ant-dropdown-menu-item {
		color: var(--theme-text-color-darken);
		font-size: .24rem;
		height: .8rem;
		padding: 0 .19rem;
		line-height: .8rem;
		margin: 0;
		min-width: 1.7rem;
		text-align: left
	}

	.top-selectDownArrow .van-but_ton {
		border-radius: .1rem 0 0 .1rem;
		font-size: .22rem;
		height: .52rem;
		margin-left: .1rem;
		padding: 0 .38rem;
	}

	.top-selectDownArrow .ant-dropdown-trigger {
		-ms-flex-align: center;
		-ms-flex-pack: center;
		align-items: center;
		background-color: var(--theme-primary-color);
		border-color: var(--theme-primary-color);
		border-radius: 0 .1rem .1rem 0 !important;
		color: var(--theme-primary-font-color);
		display: -ms-flexbox;
		display: flex;
		height: .52rem;
		transition: .3;
		justify-content: center;
		margin-left: -.01rem;
		position: relative;
		width: .4rem;
	}

	.ant-dropdown-trigger.ant-dropdown-open>svg {
		-webkit-transform: rotate(180deg);
		transform: rotate(180deg)
	}

	.top-selectDownArrow .ant-dropdown-trigger:after {
		background: var(--theme-primary-font-color);
		content: "";
		display: block;
		height: .24rem;
		left: 0;
		opacity: .3;
		position: absolute;
		top: .15rem;
		width: .01rem
	}

	.top-selectDownArrow {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
	}

	.pCKI81C6T6W2e4ZAfsHW {
		background-color: var(--theme-top-nav-bg);
		/* border-bottom: .01rem solid var(--theme-color-line); */
		height: var(--theme-header-height);
		line-height: normal;
		padding: 0;
	}

	.van-nav-bar {
		background-color: var(--theme-top-nav-bg);
	}

	.bkh5uQUT1mtuXLoAMzMG {
		color: var(--theme-text-color-lighten);
		font-size: .263rem;
		margin: 0 .25rem 0 .08rem;
		-webkit-transform: rotate(180deg);
		transform: rotate(180deg);
		transition: .3s;
	}

	.yejv0HlPp2rPD2V4Tg4O .fs20 {
		color: var(--theme-text-color-lighten) !important;
		transition: .3s;
	}

	.yejv0HlPp2rPD2V4Tg4O .fs201 {
		color: var(--theme-text-color-lighten) !important;
		-webkit-transform: rotate(-180deg);
		transform: rotate(-180deg);
		transition: .3s;
	}

	.bkh5uQUT1mtuXLoAMzMG {
		font-size: .36rem;
		margin: 0 .2rem 0 0;
	}

	._Hp2NEpB_AxXucPPcXBD {
		/* position: fixed; */
		top: 0;
		width: 100%;
		z-index: 9999;

	}

	.XmxJUtbUHHdaQg3o2iDA {
		display: flex;
		justify-content: center;
		align-content: center;
	}

	.yejv0HlPp2rPD2V4Tg4O .k2aKMnWti6qDRzhUpO8W {
		display: -ms-flexbox;
		display: flex;
		height: .74rem;
		margin-left: 0;
		max-width: 3.3rem;
		min-width: 1.8rem;
	}

	.ant-layout {
		display: flex;
		align-items: center;
	}

	.II_5ZM4k4hTlrmJknbDi {
		cursor: pointer;
		-o-object-fit: contain;
		object-fit: contain;
	}

	.customLogo {
		height: 100%;
		width: auto;
		max-width: 100%;
		object-fit: contain;
	}

	.crcd82r1PVsQivOcCftk button:first-child {
		/* margin-right: .2rem; */
	}

	.crcd82r1PVsQivOcCftk button {
		height: .51rem;
		font-size: .22rem;
		min-width: 1rem;
		padding: 0 .31rem;
		border-radius: .1rem;
	}

	.yejv0HlPp2rPD2V4Tg4O .geSGAKCHnajLSE515jEg {
		-ms-flex-negative: 0;
		-ms-flex-align: center;
		align-items: center;
		display: -ms-flexbox;
		display: flex;
		flex-shrink: 0;
		position: static !important;
	}

	.yejv0HlPp2rPD2V4Tg4O .FAoJf6QlYLI4Sv32WCTh {
		color: var(--theme-text-color);
		font-size: .25rem;
		margin-left: .15rem;
	}

	.yejv0HlPp2rPD2V4Tg4O .FAoJf6QlYLI4Sv32WCTh .fs20 {
		font-size: .25rem;
		width: .25rem;
		height: .25rem;
		color: var(--theme-text-color) !important;
	}
</style>
